<template>
  <BottomSheet :open="open" :title="t('install.title')" @close="$emit('close')">
    <p class="install-sheet__lede">{{ t('install.body') }}</p>

    <template v-if="!isIos">
      <PrimaryCTA :block="true" @click="onNativeInstall">
        {{ t('install.action') }}
      </PrimaryCTA>
    </template>

    <template v-else>
      <ol class="install-sheet__steps">
        <li v-for="key in iosSteps" :key="key">{{ t(key) }}</li>
      </ol>
    </template>

    <template #footer>
      <SecondaryCTA :block="true" @click="$emit('close')">{{ t('common.close') }}</SecondaryCTA>
    </template>
  </BottomSheet>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import BottomSheet from './BottomSheet.vue';
import PrimaryCTA from '../controls/PrimaryCTA.vue';
import SecondaryCTA from '../controls/SecondaryCTA.vue';
import { iosInstallSteps } from '@/composables/useInstallPrompt';

defineProps<{
  open: boolean;
  isIos: boolean;
}>();

const emit = defineEmits<{
  close: [];
  install: [];
}>();

const { t } = useI18n();
// Safari 26/27 moved Share into a menu — the steps follow this phone's Safari, not one generic list.
const iosSteps = iosInstallSteps(typeof navigator === 'undefined' ? '' : navigator.userAgent);

function onNativeInstall() {
  emit('install');
}
</script>

<style scoped lang="scss">
.install-sheet__lede {
  margin: 4px 0 16px;
  font-size: 14px;
  color: var(--text-2);
  line-height: 1.5;
}

.install-sheet__steps {
  margin: 4px 0 16px;
  padding: 0 0 0 22px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  li {
    font-size: 14px;
    color: var(--text);
    line-height: 1.45;
  }
}
</style>
